
export const AD = {
  primary: "#0a474c",
  primarySoft: "#ebf5f3",
  accent: "#fec000",

  text: "#4A4A4A",
  textMuted: "#6E6E6E",
  textHint: "#B9B9B9",
  onPrimary: "#fff",

  surface: "#fff",
  surfaceSubtle: "#fafafa",
  surfaceSunken: "#f5f5f5",
  canvas: "#F6F7FF",
  border: "#e0e0e0",
  borderSubtle: "#f0f0f0",

  success: "#4caf50",
  warning: "#FFC260",
  warningStrong: "#e65100",
  warningSoft: "#FFF8E1",
  error: "#f44336",
  pending: "#e65100",

  backdropSolid: "#000",

  decorStrong: "#0a474c",
  decorAccent: "#fec000",
  decorSoft: "#7BA8A3",
  decorTint: "#A9C9C4",

  radius: 6,
  radiusLg: 8,
  radiusPill: 999,

  shadowNone: "none",
  shadowCard: "0 1px 3px rgba(0,0,0,0.06)",

  controlHeight: 36,
  controlHeightSm: 28,
  controlPadX: 14,
};

export default AD;
